import { IMappers } from '../../../../common/repositories/price-estimator/v2/create-realty';
import { HttpBadStatusCodeError } from '@cian/peperrors/shared';
import { ICreateRealtyResponseV2Schema } from '../../../../common/repositories/price-estimator/entities/web/CreateRealtyResponseV2Schema';

export const createSubmitFlatDataMapper = (): IMappers<TMappedResponse200, TMappedResponse400> => ({
  200: response => response.dataPaymentFormUrl,
  400: ({ message }) => {
    return new HttpBadStatusCodeError({
      domain: '',
      statusCode: 400,
      message: message || '',
    });
  },
});

export type TMappedResponse200 = ICreateRealtyResponseV2Schema['dataPaymentFormUrl'];
export type TMappedResponse400 = HttpBadStatusCodeError;
